export const formatTextForRemoveUnderScore = (text) => {
  if (!text) return text;

  // Split by underscore and convert to title case
  return text
    .replace(/_/g, " ")
    .replace(/\+/g, "")
    // .split(" ")
    // .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    // .join(" ");
};
